@if(titulo){
  <app-crud-edit
  #editTitulo
  [apiService]="tituloService"
  [fields]="fields"
  [title]="'título'"
  [description]="'En esta sección podrás editar el detalle del Título'"
  (selectFieldValueEmit)="reloadCaracterByNivel($event)"
  ></app-crud-edit>
}
